import { FC } from 'react';

import { LoginForm } from '@shared/components/LoginForm';
import { useAuth } from '@shared/state/hooks/useAuth';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import GiftSellerAuthRouter from './GiftSellerAuthRouter';

const GiftSellerLoginPage: FC = () => {
  const redirectUrl =
    sessionStorage.getItem('redirectUrlAfterGiftSellerLogin') ?? '/gift-seller';
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="w-full max-w-md rounded-lg bg-white p-8 shadow">
        <h1 className="mb-6 text-center text-xl font-bold">답례품 판매자 로그인</h1>
        <LoginForm redirectUrl={redirectUrl} />
      </div>
    </div>
  );
};

export const GiftSellerRouter: FC = function GiftSellerRouter() {
  const { isGiftAgent, isAdmin } = useAuth();
  const { pathname, search } = useLocation();
  const isGiftSellerAuthenticated = isGiftAgent() || isAdmin();

  if (
    pathname !== '/gift-seller/login' &&
    pathname !== '/gift-seller' &&
    !isGiftSellerAuthenticated
  ) {
    sessionStorage.setItem('redirectUrlAfterGiftSellerLogin', pathname + search);
  }

  return (
    <div className="bg-white">
      <Routes>
        <Route
          path="login"
          element={
            !isGiftSellerAuthenticated ? (
              <GiftSellerLoginPage />
            ) : (
              <Navigate to="/gift-seller" />
            )
          }
        />
        <Route path="*" element={<GiftSellerAuthRouter />} />
      </Routes>
    </div>
  );
};
